import AppShell from "./components/AppShell";

export default function App() {
  return <AppShell />;
}
